import { withMainLayout } from '@view/layouts/MainLayout';
import { Route, Routes } from 'react-router-dom';
import { Routes as AppRoutes } from '../../routes';
import Addons from './Addons';
import Accommodations from './Accommodations';
import Guest from './Guest';
import Payment from './Payment';
import Confirmed from './Confirmed';
import { useEffect } from 'react';
import { Box } from '@chakra-ui/react';

const NotFoundRedirect = () => {
  useEffect(() => {
    window.location.href = '/404';
  });
  return <></>;
};

const Property = withMainLayout(() => {
  return (
    <Box>
      <Routes>
        <Route path="/" />
        <Route path={AppRoutes.Accommodations} element={<Accommodations />} />
        <Route path={AppRoutes.Addons} element={<Addons />} />
        <Route path={AppRoutes.AddGuest} element={<Guest />} />
        <Route path={AppRoutes.Payment} element={<Payment />} />
        <Route path={AppRoutes.ReservationConfirmed} element={<Confirmed />} />
        <Route path="*" element={<NotFoundRedirect />} />
      </Routes>
    </Box>
  );
});

export default Property;
